import { ENABLE_AI_PROJECTIONS_OPT_IN_SUCCEEDED, FETCH_ACCURACY_PROJECTION_FAILED, FETCH_ACCURACY_PROJECTION_STARTED, FETCH_ACCURACY_PROJECTION_SUCCEEDED, FETCH_AI_PROJECTIONS_OPT_IN_FAILED, FETCH_AI_PROJECTIONS_OPT_IN_STARTED, FETCH_AI_PROJECTIONS_OPT_IN_SUCCEEDED, FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED, FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_STARTED, FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_SUCCEEDED, FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_FAILED, FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_STARTED, FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_SUCCEEDED, FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_FAILED, FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_STARTED, FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_SUCCEEDED } from '../actions/ActionTypes';
import { requestStatuses } from '../constants/RequestStatusTypes';
const initialState = {
  accuracyProjection: {
    attemptedToGenerateForecastProjectionsThisMonth: false,
    backfillStatus: undefined,
    hasForecastProjections: false,
    accuracy: {
      isCurrentAccuracyAboveThreshold: false,
      hasPortalMetAccuracyThreshold: false,
      isLastMonthAccuracyAboveThreshold: false
    },
    submissionAccuracyOverTime: []
  },
  accuracyProjectionStatus: requestStatuses.UNINITIALIZED,
  aiProjectionsOptIn: false,
  aiProjectionsOptInStatus: requestStatuses.UNINITIALIZED,
  allTeamsThisMonthClosedWonValue: undefined,
  allTeamsThisMonthClosedWonValueStatus: requestStatuses.UNINITIALIZED,
  allTeamsThisMonthSubmission: {
    totalForecastSubmission: {
      total: undefined
    }
  },
  allTeamsThisMonthSubmissionStatus: requestStatuses.UNINITIALIZED,
  allTeamsThisMonthOverallPipelineValue: {
    amount: undefined
  },
  allTeamsThisMonthOverallPipelineValueStatus: requestStatuses.UNINITIALIZED
};
export default function analyze(state = initialState, action) {
  switch (action.type) {
    case ENABLE_AI_PROJECTIONS_OPT_IN_SUCCEEDED:
      return Object.assign({}, state, {
        aiProjectionsOptIn: true,
        aiProjectionsOptInStatus: requestStatuses.SUCCEEDED
      });
    case FETCH_AI_PROJECTIONS_OPT_IN_STARTED:
      return Object.assign({}, state, {
        aiProjectionsOptInStatus: requestStatuses.STARTED
      });
    case FETCH_AI_PROJECTIONS_OPT_IN_SUCCEEDED:
      return Object.assign({}, state, {
        aiProjectionsOptIn: action.payload,
        aiProjectionsOptInStatus: requestStatuses.SUCCEEDED
      });
    case FETCH_AI_PROJECTIONS_OPT_IN_FAILED:
      return Object.assign({}, state, {
        aiProjectionsOptInStatus: requestStatuses.FAILED
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_STARTED:
      return Object.assign({}, state, {
        allTeamsThisMonthSubmissionStatus: requestStatuses.STARTED
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_SUCCEEDED:
      return Object.assign({}, state, {
        allTeamsThisMonthSubmissionStatus: requestStatuses.SUCCEEDED,
        allTeamsThisMonthSubmission: action.payload
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED:
      return Object.assign({}, state, {
        allTeamsThisMonthSubmissionStatus: requestStatuses.FAILED
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_STARTED:
      return Object.assign({}, state, {
        allTeamsThisMonthOverallPipelineValueStatus: requestStatuses.STARTED
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_SUCCEEDED:
      return Object.assign({}, state, {
        allTeamsThisMonthOverallPipelineValueStatus: requestStatuses.SUCCEEDED,
        allTeamsThisMonthOverallPipelineValue: action.payload
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_FAILED:
      return Object.assign({}, state, {
        allTeamsThisMonthOverallPipelineValueStatus: requestStatuses.FAILED
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_STARTED:
      return Object.assign({}, state, {
        allTeamsThisMonthClosedWonValueStatus: requestStatuses.STARTED
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_SUCCEEDED:
      return Object.assign({}, state, {
        allTeamsThisMonthClosedWonValueStatus: requestStatuses.SUCCEEDED,
        allTeamsThisMonthClosedWonValue: action.payload
      });
    case FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_FAILED:
      return Object.assign({}, state, {
        allTeamsThisMonthClosedWonValueStatus: requestStatuses.FAILED
      });
    case FETCH_ACCURACY_PROJECTION_STARTED:
      return Object.assign({}, state, {
        accuracyProjectionStatus: requestStatuses.STARTED
      });
    case FETCH_ACCURACY_PROJECTION_SUCCEEDED:
      return Object.assign({}, state, {
        accuracyProjectionStatus: requestStatuses.SUCCEEDED,
        accuracyProjection: action.payload
      });
    case FETCH_ACCURACY_PROJECTION_FAILED:
      return Object.assign({}, state, {
        accuracyProjectionStatus: requestStatuses.FAILED
      });
    default:
      return state;
  }
}